<template>
  <div>
    <v-navigation-drawer v-if="items" app v-model="drawer" color="success" dark>
      <template v-slot:prepend>
        <v-list-item class="pt-1 elevation-3" color="white" style="height: 64px;" link router to="/">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-home-city</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>首页</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <menulists :items="items"></menulists>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn text block @click="$router.replace('/logout')">
            退出<v-icon>mdi-logout</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app color="success" dark>
      <v-app-bar-nav-icon v-if="items" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <span @click.stop="$route.path!='/index' && $route.path!='/' && $router.push('/')"
        class="d-inline-block text-truncate font-weight-bold">
        <v-icon>mdi-reply</v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp">{{$store.state.guser}}</span>
        <span>承诺达标合格证管理系统</span>
      </span>
      <v-dialog v-model="qrdialog" width="350">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon class="px-1">mdi-qrcode</v-icon>
          </v-btn>
        </template>
        <v-card align="center" @click="qrdialog=false" background-color="white" class="px-5 pt-3">
          <v-img src="@/assets/mpqr.jpg"></v-img>
          <v-card-text primary-title>微信扫一扫打开小程序</v-card-text>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-btn text class="pr-1" @click.stop="$route.path!='/myinfo' && $router.push('/myinfo')">
        <span v-if="$vuetify.breakpoint.xsOnly" class="ml-1 text-subtitle-2">个人资料</span>
        <span v-else>
          <span v-if="$store.state.userInfo&&$store.state.userInfo.Usersproer&&$store.state.userInfo.Usersproer.Zjpic">
            <v-avatar size="32" class="elevation-3" :color="avatarColor">
              <v-img :src="'data:image/jpeg;base64,'+$store.state.userInfo.Usersproer.Zjpic"></v-img>
            </v-avatar>
            <span class="ml-1 text-subtitle-2">{{ $store.state.userInfo&&$store.state.userInfo.Usersproer&&$store.state.userInfo.Usersproer.Name }}</span>
          </span>
          <span v-else>
            <v-avatar size="32" class="elevation-3" :color="avatarColor">
              <span class="font-weight-bold">{{$store.state.userInfo&&$store.state.userInfo.Usersproer&&$store.state.userInfo.Usersproer.Name.substr(0,1)}}</span>
            </v-avatar>
            <span class="ml-1 text-subtitle-2">{{ $store.state.userInfo&&$store.state.userInfo.Usersproer&&$store.state.userInfo.Usersproer.Name.substr(1) }}</span>
          </span>
        </span>
        <v-icon>mdi-account-edit</v-icon>
      </v-btn>
      <v-btn text class="pl-1 pr-0" @click="$router.replace('/logout')">
        <span class="ml-1 text-subtitle-2">退出</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
  import menulists from './menulists'
  export default {
    name: "Navbar",
    components: {
      menulists,
    },
    data: function () {
      return {
        drawer: !this.$vuetify.breakpoint.mobile,
        items: [],
        qrdialog: false,
      };
    },
    mounted() {
      this.$store.state.userInfo && this.$store.state.userInfo.Usersproer && this.$api.getMyMenus({ sortby: 'Sort', order: 'asc' }).then(res => {
        this.items = res.data
      })
    },
    computed: {
      avatarColor() {
        let colorlist = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'deep-orange', 'brown', 'blue-grey', 'grey']
        return colorlist[Math.floor(Math.random() * colorlist.length)]
      }
    },
  };
</script>